import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "engage-toolbar d-flex position-fixed px-5 fw-bold zindex-2 top-50 end-0 transform-90 mt-20 gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  id: "kt_engage_demos_toggle",
  class: "engage-demos-toggle btn btn-flex h-35px bg-body btn-color-gray-700 btn-active-color-gray-900 shadow-sm fs-6 px-4 rounded-top-0",
  title: "Check out more demos",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "left",
  "data-bs-dismiss": "click",
  "data-bs-trigger": "hover"
}, [
  /*#__PURE__*/_createElementVNode("span", { id: "kt_engage_demos_label" }, " Demos ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  id: "kt_help_toggle",
  class: "engage-help-toggle btn btn-flex h-35px bg-body btn-color-gray-700 btn-active-color-gray-900 shadow-sm px-5 rounded-top-0",
  title: "Learn & Get Inspired",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "left",
  "data-bs-dismiss": "click",
  "data-bs-trigger": "hover"
}, " Help ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}